import sImg1 from '../images/services/service_image_1.webp'
import sImg2 from '../images/services/service_image_2.webp'
import sImg3 from '../images/services/service_image_3.webp'
import sImg4 from '../images/services/service_image_4.webp'
import sImg5 from '../images/services/service_image_5.webp'

import icon1 from '../images/icons/icon_code.svg'
import icon2 from '../images/icons/icon_programming_tree.svg'
import icon3 from '../images/icons/icon_monitor_2.svg'
import icon4 from '../images/icons/icon_phone.svg'
import icon5 from '../images/icons/icon_bug.svg'
import icon6 from '../images/icons/icon_programming.svg'

import icon7 from '../images/icons/icon_analisis_2.svg'
import icon8 from '../images/icons/icon_process.svg'
import icon9 from '../images/icons/icon_chart_2.svg'
import icon10 from '../images/icons/icon_meeting.svg'
import icon11 from '../images/icons/icon_bulb_2.svg'
import icon12 from '../images/icons/icon_speed_miter.svg'

import akasa from '../images/productImage/akasa.png'
import arkara from '../images/productImage/arkara.png'
import awasi from '../images/productImage/awasi.png'
import lstari from '../images/productImage/lstari.png'
import netra from '../images/productImage/netra.png'
import pragati from '../images/productImage/pragati.png'
import smbrani from '../images/productImage/smbrani.png'
import bawera from '../images/productImage/bawera.png'
import maintenance from '../images/productImage/maintenance.png'

const Services = [
    {
        Id: '1',
        sImg: sImg1,
        title: 'SMBRANI (Sistem Monitoring BeRbasis Adaptasi Individu)',
        slug: 'IT-Management-Services',
        thumb1: 'Strategy',
        thumb2: 'Consultation',
        col: 'col-lg-6',
        description: 'SMBRANI (THE FUTURE OF FLEET MANAGEMENT SYSYTEM)',
    },
    {
        Id: '2',
        sImg: sImg2,
        title: 'Data Tracking and Security',
        slug: 'Data-Tracking-and-Security',
        thumb1: 'Management',
        thumb2: 'Transfer',
        col: 'col-lg-6',
        description: 'Developing your trade, setting up new sales channels Your visa is ready...',
    },
    {
        Id: '3',
        sImg: sImg3,
        title: 'Website Development',
        slug: 'Website-Development',
        thumb1: 'Landing Page',
        thumb2: 'Plugins',
        col: 'col-lg-4',
        description: 'Developing your trade, setting up new sales channels Your visa is ready...',
    },
    {
        Id: '4',
        sImg: sImg4,
        title: 'Modern Technology Solution',
        slug: 'Modern-Technology-Solution',
        thumb1: 'Consultation',
        thumb2: 'solution',
        col: 'col-lg-4',
        description: 'Embarking on a journey of higher education in a foreign country opens doors to...',
    },
    {
        Id: '5',
        sImg: sImg5,
        title: 'UI/UX Design Services',
        slug: 'UI-UX-Design-Services',
        thumb1: 'Website',
        thumb2: 'Mobile App',
        col: 'col-lg-4',
        description: 'Expert Guidance for a Seamless Immigration Journey Expert Guidance...',
    },
    {
        Id: '6',
        sImg: icon1,
        title: 'SMBRANI (Sistem Monitoring Berbasis Adaptasi Individu)',
        slug: 'SMBRANI',
        features: ['CUSTOMISABLE & POWERFUL REPORTING TOOLS', 'EXISTING COMMUNICATION INFRASTRUCTURE (GSM / LTE/ WIFI)', 'SOPHISTICATED EVENTS ENGINE'],
        description: 'Tailored Network and System Monitoring for Dynamic Environments <br/> <br/>SMBRANI provides a comprehensive monitoring solution designed to adapt to your specific organizational needs. By leveraging your existing communication networks, it delivers profound visibility into your IT and operational infrastructure, ensuring you stay ahead of potential issues with highly customizable reporting and alerting mechanisms.',
        keys: 'Customisable & Powerful Reporting Tools: Generate in-depth, tailored reports that give actionable insights into network health, bandwidth usage, and overall system performance. <br/><br/> Existing Communication Infrastructure: Seamlessly utilizes your current GSM, LTE, or Wi-Fi networks to transmit telemetry data, eliminating the need for costly secondary network deployments. <br/><br/> Sophisticated Events Engine: Employs an advanced rule-based engine to instantly categorize, filter, and alert your Network Operations Center (NOC) team to critical system events before they escalate.',
        productImage: smbrani
    },
    {
        Id: '7',
        sImg: icon2,
        title: 'AKASA (Akses Komunikasi Alternatif dan Stabil)',
        slug: 'AKASA',
        features: [
            'POWERED BY STARLINK',
            'HIGH-SPEED CONNECTIVITY',
            'LONG-RANGE COVERAGE AND MOBILITY',
            'EASE OF INSTALLATION & FLEXIBILITY'
        ],
        description: 'Reliable, High-Speed Connectivity for the Most Remote Frontiers <br/><br/>AKASA ensures that geographical barriers never hinder your business operations. Designed for industries operating in remote and exploratory regions, this solution leverages advanced satellite technology to provide a steadfast, high-speed communication lifeline where traditional terrestrial networks fall short.',
        keys: 'Powered by Starlink: Integrates cutting-edge Low Earth Orbit (LEO) satellite technology for low-latency, enterprise-grade internet access anywhere on the map. <br/><br/> High-Speed Connectivity: Delivers robust bandwidth capable of supporting demanding corporate applications, video conferencing, and real-time data transfers from the field. <br/><br/> Long-Range Coverage and Mobility: Ensures uninterrupted communication across expansive and isolated sites, perfect for mining operations, offshore rigs, and exploration camps. <br/><br/> Ease of Installation & Flexibility: Rapid deployment capabilities with a minimal hardware footprint, allowing your technical team to establish secure connections almost instantly.',
        productImage: akasa
    },
    {
        Id: '8',
        sImg: icon3,
        title: 'NETRA (Navigasi Efisien dengan Teknologi Real-time Adaptif)',
        slug: 'NETRA',
        features: [
            'ENHANCED OPERATIONAL EFFICIENCY',
            'IMPROVED DECISION-MAKING',
            'SCALABILITY AND FLEXIBILITY'
        ],
        description: 'Adaptive Real-Time Navigation and Operational Tracking <br/><br/>NETRA is engineered to optimize your field operations through precise, real-time tracking and adaptive navigation technologies. It empowers decision-makers with live locational data and logistical insights, streamlining the movement of assets, fleets, and personnel across complex operational landscapes.',
        keys: 'Enhanced Operational Efficiency: Reduces transit times and logistical bottlenecks by providing optimal routing, geo-fencing, and live field coordination. <br/><br/> Improved Decision-Making: Delivers a comprehensive live dashboard that allows management to make rapid, informed decisions based on accurate geospatial data. <br/><br/> Scalability and Flexibility: Easily scales from tracking a small fleet of operational vehicles to managing complex logistics across multiple remote project sites simultaneously.',
        productImage: netra
    },
    {
        Id: '9',
        sImg: icon4,
        title: 'LSTARI (Layanan Sistem Terpadu Aset Regulasi Internal)',
        slug: 'LSTARI',
        features: [
            'ENHANCED PRODUCTIVITY',
            'COST EFFICIENCY',
            'CUSTOMIZABLE AND UP-TO-DATE SERVICE'
        ],
        description: 'Comprehensive IT Asset and Internal Compliance Management <br/><br/>LSTARI digitizes and centralizes the management of your company\'s physical and digital assets. It provides a structured framework for tracking hardware lifecycles, managing deployments, and ensuring regulatory compliance, giving your operations team complete control over your corporate inventory and IT infrastructure.',
        keys: 'Enhanced Productivity: Automates asset tracking, administrative logging, and deployment documentation, freeing up your technical staff to focus on critical operations rather than manual paperwork. <br/><br/> Cost Efficiency: Minimizes asset loss and optimizes procurement strategies by providing clear visibility into hardware status, depreciation, and maintenance schedules. <br/><br/> Customizable and Up-to-Date Service: A flexible management platform that adapts to your specific internal regulations and auditing requirements, keeping your compliance records continuously updated.',
        productImage: lstari
    },
    {
        Id: '10',
        sImg: icon5,
        title: 'BAWERA (Bandwidth Akses Wilayah Eksploratif Ringkas Alat)',
        slug: 'BAWERA',
        features: [
            'ENHANCED BANDWIDTH EFFICIENCY',
            'SCALABLE SOLUTIONS',
            'LOWER OPERATIONAL COSTS',
            'REDUCED PHYSICAL FOOTPRINT'
        ],
        description: 'Optimized Bandwidth Solutions for Compact and Exploratory Deployments <br/><br/>BAWERA provides highly efficient bandwidth management designed specifically for exploratory missions and temporary operational bases. Utilizing compact, high-performance network equipment like point-to-point radio links, it maximizes data throughput while minimizing the physical and logistical footprint required for deployment.',
        keys: 'Enhanced Bandwidth Efficiency: Employs advanced traffic shaping, routing protocols, and compression techniques to maximize the utility of your available network capacity. <br/><br/> Scalable Solutions: Effortlessly upgrades from supporting a small exploratory survey team to a full-scale operational base without major architectural overhauls. <br/><br/> Lower Operational Costs: Reduces the need for extensive hardware investments and costly logistical transport through highly efficient, focused deployments. <br/><br/> Reduced Physical Footprint: Deploys easily in constrained environments using streamlined equipment, perfect for temporary sites, rapid response units, or challenging terrains.',
        productImage: bawera
    },
    {
        Id: '11',
        sImg: icon6,
        title: 'Maintenance and Customer Support',
        slug: 'Maintenance-and-Customer-Support',
        features: [
            'CARECRAFT MAINTENANCE',
            'FIXITPRO MAINTENANCE',
            'TECHCARE MAINTENANCE',
            'ASSISTEDGE MAINTENANCE'
        ],
        description: 'Tiered Technical Support and Proactive System Care <br/><br/>Our commitment to your operational success extends far beyond deployment. We offer a comprehensive suite of maintenance and customer support packages tailored to ensure the continuous reliability, security, and peak performance of your IT and network infrastructure, backed by our professional technical team.',
        keys: 'CareCraft Maintenance: Preventative care and routine health checks to ensure baseline system stability and hardware longevity. <br/><br/> FixItPro Maintenance: Rapid-response troubleshooting and reactive repair services to quickly resolve unexpected hardware failures or software glitches. <br/><br/> TechCare Maintenance: Comprehensive IT support including software configurations, patch management, and dedicated technical consulting. <br/><br/> AssistEdge Maintenance: Premium, around-the-clock priority support with dedicated Service Level Agreements (SLAs) for your mission-critical infrastructure.',
        productImage: maintenance
    },
    {
        Id: '12',
        sImg: icon7,
        title: 'PRAGATI (Pusat Rekayasa Automasi & Gabungan Teknologi IoT)',
        slug: 'PRAGATI',
        features: ['REAL-TIME ASSET MONITORING', 'AUTOMATED WORKFLOW & REPORTING', 'PREDICTIVE MAINTENANCE', 'SEAMLESS SYSTEM INTEGRATION'],
        description: 'Custom System Development and IoT Ecosystems for Operational Automation <br/> <br/>PRAGATI focuses on building and integrating bespoke software and IoT hardware to streamline your entire operational workflow. Rather than visual surveillance, PRAGATI acts as the digital nervous system of your IT and Network Operations Center (NOC). We develop custom data pipelines, deploy physical telemetry sensors, and automate administrative systems to ensure your infrastructure runs with maximum efficiency.',
        keys: 'Custom System Development: Tailor-made software engineering, including the development of bespoke Telegram bots for automated daily reporting, attendance logging, and instant system alerts. <br/><br/> IoT Sensor Networks: Deployment of physical hardware sensors to monitor critical environmental metrics—such as data center temperatures, power fluctuations, and network health—in real-time. <br/><br/> Centralized Asset Management: Seamless integration with robust inventory platforms like Snipe-IT to track hardware lifecycles, streamline corporate asset administration, and digitize auditing processes. <br/><br/> Data-Driven Workflows: Replacing manual administrative tasks with automated, interconnected IT systems that bridge the gap between field infrastructure and management dashboards.',
        productImage: pragati
    },
    {
        Id: '13',
        sImg: icon8,
        title: 'ARKARA (Akses Resiliensi & Konsumsi Arus Ramah Alam)',
        slug: 'ARKARA',
        features: ['HYBRID SOLAR POWER SOLUTIONS', 'SMART ENERGY EFFICIENCY', 'SUSTAINABLE INFRASTRUCTURE', 'REDUCED CARBON FOOTPRINT'],
        description: 'Sustainable Energy Solutions for Resilient Technology Infrastructure <br/> <br/>Network reliability must not be interrupted by power supply constraints, especially in remote operational sites. ARKARA ensures connectivity resilience through the smart utilization of green energy. This solution not only guarantees maximum uptime but also supports your companys sustainability commitments',
        keys: 'Hybrid Solar Power Solutions: Implementation of integrated solar panels with advanced battery storage systems to supply power to crucial infrastructure, such as Backbone Radio Links and Access Points, even in off-grid or mining areas. <br/><br/> Smart Energy Efficiency: Intelligently managed power distribution to prioritize primary devices when energy supply is limited, maintaining the stability of essential communication services. <br/><br/> Sustainable Infrastructure: Fully supports eco-friendly initiatives and Waste Management by extending device lifespans through stable power supply, thereby reducing electronic waste (e-waste). <br/><br/> Reduced Carbon Footprint: A concrete step towards net-zero emissions by reducing reliance on fossil fuel generators, lowering carbon emissions while significantly cutting fuel operational costs.',
        productImage: arkara
    },
    {
        Id: '14',
        sImg: icon9,
        title: 'AWASI (Analitik Visual Adaptif & Sistem Inspeksi)',
        slug: 'AWASI',
        features: ['AI-POWERED COMPUTER VISION', 'HSE COMPLIANCE MONITORING', 'AUTOMATED ANOMALY DETECTION', 'SMART INTRUSION CONTROL'],
        description: 'Customizable AI Vision and Smart CCTV Analytics <br/> <br/>AWASI is a dedicated computer vision solution designed to transform passive CCTV networks into active, intelligent observers. Driven entirely by customer-specific requirements, we develop and deploy Custom AI models that overlay onto your camera infrastructure. Whether you need to count vehicles, enforce safety protocols, or secure perimeters, AWASI provides bespoke visual analytics tailored to your unique operational environment.',
        keys: 'Custom AI Development: Tailor-made machine learning models trained specifically to meet your exact project requirements and recognize the unique visual data of your industry. <br/><br/> Smart CCTV Integration: Seamlessly adds an intelligent analytics layer to existing or newly deployed camera networks without needing complete hardware overhauls. <br/><br/> HSE Compliance Vision: Automated visual detection for strict safety protocols, such as ensuring personnel are wearing correct Personal Protective Equipment (PPE) in high-risk zones. <br/><br/> Dynamic Visual Alerts: Triggers instant, customized warnings to your control center the moment the AI detects unauthorized access, safety anomalies, or specific predefined events.',
        productImage: awasi
    },
    // {
    //     Id: '12',
    //     sImg:icon7,
    //     title: 'Strategic Planning and Execution',
    //     slug: 'Strategic-Planning-and-Execution',
    //     description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
    // },
    // {
    //     Id: '13',
    //     sImg:icon8,
    //     title: 'Business Process Optimization',
    //     slug: 'Business-Process-Optimization',
    //     description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
    // },
    // {
    //     Id: '14',
    //     sImg:icon9,
    //     title: 'Digital Transformation Consulting',
    //     slug: 'Digital-Transformation-Consulting',
    //     description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
    // },
    // {
    //     Id: '15',
    //     sImg:icon10,
    //     title: 'Strategic Planning and Execution',
    //     slug: 'Strategic-Planning-and-Executions',
    //     description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
    // },
    // {
    //     Id: '16',
    //     sImg:icon11,
    //     title: 'Change Management Solutions',
    //     slug: 'Change-Management-Solutions',
    //     description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
    // },
    // {
    //     Id: '17',
    //     sImg:icon12,
    //     title: 'Performance Metrics and KPI Development',
    //     slug: 'Performance-Metrics-and-KPI-Development',
    //     description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
    // },
]

export default Services;
